import ReactGA from "react-ga4";
import LinkedInTag from "react-linkedin-insight";

export const emitGoogleTrack = (data: Record<any, any>) => {
  ReactGA.event(data.event, {
    ...data,
    event: undefined,
  });
};

export const emitFacebookTrack = (event: string, data?: Record<any, any>) => {
  import("react-facebook-pixel")
    .then((x) => x.default)
    .then((ReactPixel) => ReactPixel.trackCustom(event, data));
};

export const emitLinkedinTrack = (id: string) => {
  LinkedInTag.track(id);
};
